// 明星黑料首页数据：导航、跑马灯、话题墙、最新挖掘帖

export interface NavItem {
  key: string;
  label: string;
}

export interface MarqueeItem {
  id: string;
  text: string;
  kind: string; // 实锤 / 录音 / 聊天 / 截图
}

export interface Hashtag {
  id: string;
  tag: string;
  hot: string; // 热度数值
  delta: string; // 上升
  spikes: number[]; // 迷你热度走势
}

export interface FeedPost {
  id: string;
  category: string; // 实锤 / 录音 / 聊天 / 截图 / 通告
  cover: string;
  title: string;
  lead: string;
  source: string;
  evCount: number; // 证据条数
  comments: number;
  hot: string;
  time: string;
  pined?: boolean;
}

export const navChannels: NavItem[] = [
  { key: 'new', label: '最新挖掘' },
  { key: 'hammer', label: '实锤合集' },
  { key: 'audio', label: '录音曝光' },
  { key: 'chat', label: '聊天记录' },
  { key: 'rank', label: '人物热榜' },
  { key: 'zone', label: '吃瓜专区' },
];

export const marqueeHeadlines: MarqueeItem[] = [
  { id: 'm1', text: '某顶流恋爱综艺期间被扒出与圈外素人同居实锤', kind: '实锤' },
  { id: 'm2', text: '疑似酒局录音流出：资方高层谈改番内幕，全程高能', kind: '录音' },
  { id: 'm3', text: '工作室内部聊天记录曝光，粉丝刷榜数据被坐实', kind: '聊天' },
  { id: 'm4', text: '机场代拍截图对比，同一顶咖两副面孔早有端倪', kind: '截图' },
  { id: 'm5', text: '剧组群演实锤帖：某小花片场耍大牌细节整理成册', kind: '实锤' },
  { id: 'm6', text: '百万级录音：经纪人私下吐槽艺人业务能力的原声片段', kind: '录音' },
  { id: 'm7', text: '饭圈内部群聊截图曝光，大粉带头集资的操作全流程', kind: '聊天' },
  { id: 'm8', text: '综艺切片逐帧对比，所谓真性情被网友扒出剧本痕迹', kind: '截图' },
];

export const hotHashtags: Hashtag[] = [
  { id: 'h1', tag: '#顶流塌房倒计时', hot: '1284万', delta: '爆', spikes: [6, 8, 5, 9, 7, 10, 8] },
  { id: 'h2', tag: '#录音门·番位之争', hot: '967万', delta: '升', spikes: [4, 6, 8, 7, 9, 8, 10] },
  { id: 'h3', tag: '#小花人设崩塌现场', hot: '821万', delta: '爆', spikes: [7, 5, 6, 8, 7, 9, 8] },
  { id: 'h4', tag: '#代拍镜头下的真相', hot: '603万', delta: '升', spikes: [5, 7, 6, 8, 9, 7, 8] },
  { id: 'h5', tag: '#综艺剧本实锤', hot: '512万', delta: '新', spikes: [3, 5, 7, 9, 8, 9, 10] },
  { id: 'h6', tag: '#饭圈集资黑幕', hot: '486万', delta: '升', spikes: [4, 4, 6, 7, 8, 8, 9] },
  { id: 'h7', tag: '#偷税名单还在加', hot: '439万', delta: '升', spikes: [5, 8, 7, 6, 9, 8, 7] },
  { id: 'h8', tag: '#塌房考古三连', hot: '372万', delta: '稳', spikes: [6, 6, 7, 6, 8, 7, 7] },
  { id: 'h9', tag: '#CP营业营业天花板', hot: '298万', delta: '新', spikes: [3, 4, 5, 6, 8, 9, 8] },
  { id: 'h10', tag: '#素人爆料集中营', hot: '241万', delta: '升', spikes: [4, 6, 5, 7, 6, 8, 9] },
];

export const feedPosts: FeedPost[] = [
  {
    id: 'f1',
    category: '实锤',
    cover: 'https://readdy.ai/api/search-image?query=paparazzi%20long%20lens%20shot%20of%20celebrity%20couple%20entering%20apartment%20at%20night%2C%20faces%20pixelated%20blurred%2C%20moody%20street%20lighting%2C%20dark%20red%20and%20amber%20tones%2C%20grainy%20gossip%20magazine%20editorial%2C%20high%20contrast%2C%20covert%20surveillance%20aesthetic&width=640&height=400&seq=gossip-f1&orientation=landscape',
    title: '恋爱综艺录制期同居？顶流男星被拍到连续两周同出入公寓',
    lead: '狗仔蹲守近一个月，画面时间线完整可考。同款窗帘、同色车型比对图已整理，评论区网友逐帧考古指认痕迹明显。',
    source: '匿名狗仔 实拍档案',
    evCount: 23,
    comments: 4589,
    hot: '87°',
    time: '12分钟前',
    pined: true,
  },
  {
    id: 'f2',
    category: '录音',
    cover: 'https://readdy.ai/api/search-image?query=audio%20recording%20studio%20with%20warm%20table%20lamp%20and%20coffee%20cups%2C%20two%20shadowy%20silhouettes%20in%20backlit%20meeting%2C%20mysterious%20wiretapping%20atmosphere%2C%20deep%20burgundy%20and%20gold%20tones%2C%20grainy%20noir%20documentary%20style&width=640&height=400&seq=gossip-f2&orientation=landscape',
    title: '两分钟关键切片：资方高管饭局原声，亲口谈「按资历改番」',
    lead: '录音里能清楚听到几位圈内人的对话语气，涉及角色、排位与人情账。文字逐句转写稿已同步放出，欢迎对时间轴。',
    source: '夜谈实录 声音档案',
    evCount: 9,
    comments: 3671,
    hot: '82°',
    time: '41分钟前',
  },
  {
    id: 'f3',
    category: '聊天',
    cover: 'https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20messaging%20app%20chat%20interface%20held%20in%20hand%2C%20blurred%20text%20bubbles%2C%20warm%20desk%20lamp%20glow%2C%20dark%20background%2C%20grainy%20editorial%20photo%2C%20documentary%20evidence%20style&width=640&height=400&seq=gossip-f3&orientation=landscape',
    title: '工作室运营群截图流出：控评、清词、刷数据排期一目了然',
    lead: '群公告里把每次宣传节点拆得明明白白，谁负责水军、谁盯热搜位都有分工。多名前员工口供与此互相印证。',
    source: '内部群聊 存档截图',
    evCount: 31,
    comments: 2904,
    hot: '78°',
    time: '1小时前',
  },
  {
    id: 'f4',
    category: '截图',
    cover: 'https://readdy.ai/api/search-image?query=collage%20of%20airport%20photographs%20of%20celebrity%20in%20two%20different%20public%20moods%2C%20one%20waving%20warmly%20one%20turning%20away%2C%20faces%20blurred%2C%20flash%20photography%2C%20newsprint%20texture%2C%20amber%20and%20ink%20tones%2C%20tabloid%20montage%20layout&width=640&height=400&seq=gossip-f4&orientation=landscape',
    title: '同一顶咖机场两副面孔：见镜头前与无镜头对照图全整理',
    lead: '代拍同时段的两种状态被拼接成对照组，粉丝洗白文案与现实画面偏差肉眼可见，逐帧图源均已打码留档。',
    source: '站姐观察 素材比对',
    evCount: 16,
    comments: 2338,
    hot: '74°',
    time: '2小时前',
  },
  {
    id: 'f5',
    category: '实锤',
    cover: 'https://readdy.ai/api/search-image?query=movie%20set%20behind%20the%20scenes%20at%20night%2C%20director%20chair%20and%20trailer%20lights%2C%20blurred%20production%20crew%2C%20red%20warning%20tape%2C%20warm%20cinematic%20light%2C%20documentary%20behind%20scenes%20editorial%2C%20grainy%20film%20texture&width=640&height=400&seq=gossip-f5&orientation=landscape',
    title: '群演实名实锤：某小花高温外景断水断饭，全程替身补镜',
    lead: '多份当日排班表与天气记录对上号，出场时长统计表显示本人戏份占比不足三成。聊天记录补充了现场抱怨细节。',
    source: '剧组工人 联合举证',
    evCount: 44,
    comments: 1986,
    hot: '71°',
    time: '3小时前',
  },
  {
    id: 'f6',
    category: '录音',
    cover: 'https://readdy.ai/api/search-image?query=vintage%20audio%20recorder%20and%20microphone%20on%20wooden%20table%2C%20sound%20wave%20shapes%20in%20air%2C%20warm%20low%20light%2C%20deep%20gold%20and%20brown%20palette%2C%20moody%20podcast%20studio%2C%20editorial%20still%20life&width=640&height=400&seq=gossip-f6&orientation=landscape',
    title: '经纪人酒后录音流出：私下抱怨艺人「业务能力全靠滤镜」',
    lead: '一段不到一分钟的吐槽，把片场替身、台词背不下来、价格虚高等老话全抖出来，圈内人听后直呼「说太满」。',
    source: '酒局回声 私密录制',
    evCount: 6,
    comments: 1742,
    hot: '68°',
    time: '5小时前',
  },
  {
    id: 'f7',
    category: '聊天',
    cover: 'https://readdy.ai/api/search-image?query=group%20chat%20screenshots%20spread%20out%20on%20desk%20with%20phone%2C%20money%20transfer%20interfaces%20blurred%2C%20night%20study%20room%20desk%20lamp%2C%20dark%20tones%2C%20forensic%20evidence%20photo%2C%20documentary%20feel&width=640&height=400&seq=gossip-f7&orientation=landscape',
    title: '大粉群集资全流程截图：买号、压评、冲量一条龙清晰可见',
    lead: '从收款到投放再到「战报」，每个环节都有人对账。涉及金额估算过百万，转账截图时间与活动节点严丝合缝。',
    source: '前大粉 退圈供料',
    evCount: 52,
    comments: 1421,
    hot: '65°',
    time: '7小时前',
  },
  {
    id: 'f8',
    category: '截图',
    cover: 'https://readdy.ai/api/search-image?query=side%20by%20side%20video%20still%20frames%20of%20reality%20show%20scenes%2C%20producer%20clipboard%20and%20script%20in%20foreground%2C%20warm%20studio%20lighting%2C%20blurred%20cast%2C%20grainy%20documentary%20production%20photo&width=640&height=400&seq=gossip-f8&orientation=landscape',
    title: '综艺切片逐帧比对：所谓「真情流露」被扒出剧本痕迹',
    lead: '同一句台词在两期节目里神态复读，剪辑把删掉的穿帮画面都暴露了。网友自制时间轴对照已成爆款热帖。',
    source: '显微镜考据组',
    evCount: 12,
    comments: 1180,
    hot: '62°',
    time: '9小时前',
  },
];